<template>
  <div>
    <div class="search-flex">
      <!-- 搜索框 -->
      <div>
        <el-input class="search_input" clearable placeholder="批次ID" size="small" v-model="searchParams.id"></el-input>
        <el-input class="search_input" clearable placeholder="激活码名称" size="small" v-model="searchParams.cdkeyName">
        </el-input>
        <!-- 业务类型 -->
        <el-select class="search_input" clearable placeholder="业务类型" size="small" v-model="searchParams.businessType">
          <el-option v-for="item in businessTypeList.value" :key="item.value" :label="item.label" :value="item.value">
          </el-option>

        </el-select>
      </div>
      <div>
        <!-- 搜索按钮 -->
        <el-button v-auth="'ACTIVE_CODE_GENERATE_SEARCH'" type="primary" size="small" @click="search">搜索</el-button>
        <!-- 新增按钮 -->
        <el-button v-auth="'ACTIVE_CODE_GENERATE_ADD'" size="small" @click="add">新增</el-button>
        <!-- 导出按钮 -->
        <el-button v-auth="'ACTIVE_CODE_GENERATE_EXPORT'" size="small" type="success"
          @click="exportActiveCode">导出激活码</el-button>
      </div>
    </div>
    <AddDialog ref="addDialog"></AddDialog>
  </div>
</template>

<script>
import Message from "@/components/Message";
import AddDialog from "./Add.vue";
export default {
  inject: ["searchParams", "businessTypeList", "getList", "activeGoodList", "getActiveGoodsList"],
  provide() {
    return {
      activeGoodList: this.activeGoodList,
      getList: this.getList,
      getActiveGoodsList: this.getActiveGoodsList,
    };
  },
  name: "WebSaaSSearch",
  components: {
    AddDialog,
  },
  data() {
    return {};
  },

  methods: {
    /** 导出激活码 */
    exportActiveCode() {

      this.$emit('exportActiveCode')
    },
    /** 搜索 */
    search() {
      console.log("搜索", this.searchParams);
      this.getList();
      Message.success("搜索成功");
    },
    /** 新增 */
    add() {
      this.$refs.addDialog.show();
    },
  },
};
</script>

<style lang="scss" scoped>
.search-flex {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.search_input {
  width: 160px !important;
  margin: 10px 20px 0 0;
}

::v-deep .el-select__tags {
  flex-wrap: nowrap !important;
}
</style>